<template>
    <div class="index">
        <!-- banner -->
        <slider :sliderData="sliderData"></slider>
        <!-- 部门简介 -->
        <div class="bmjj margin-t50">
          <div class="w69">
            <div class="comTitle">
                <p>部门简介</p>
                <span>DEPARTMENT PROFILE</span>
                <em></em>
            </div>
            <div class="jjBox">
              <p class="jjImg"><span><img :src="bmjj.Photo" alt=""></span></p>
              <p class="details" v-html="bmjj.Info"></p>
            </div>
          </div>
        </div>
        <!-- 无图新闻(信息公告+人事政策) -->
        <div class="wutuDiv1">
          <div class="w69">
            <xxgg :xxggList='xxggList' moreLink = "/list.html?HType=2&CId=5607"></xxgg>
            <!-- <rszc :rszcList='rszcList' moreLink = "/list.html?HType=2&CId=5608"></rszc> -->
            <zcpp :zcppList='zcppList' moreLink = "/list.html?HType=2&CId=5610"></zcpp>
          </div>
        </div>
        <br>
        <!-- 无图新闻（职称评聘+师资建设） -->
        <!-- <div class="wutuDiv2">
          <div class="w69">
            <szjs :szjsList='szjsList' moreLink = "/list.html?HType=2&CId=5614"></szjs>
          </div>
        </div> -->

    </div>
</template>
<script>
import '../assets/css/index.css';
import '../assets/js/init.js';
import '../assets/js/wow.js';
import slider from '@/components/slider';
import xxgg from '@/components/xxgg';
import rszc from '@/components/rszc';
import zcpp from '@/components/zcpp';
import szjs from '@/components/szjs';
export default {
    name:'index',
    components:{
        slider,
        xxgg,
        rszc,
        zcpp,
        szjs
    },
    data(){
        return{
            baseUrl:'this.baseUrl',
            sliderData:[],
            xxggList:[],
            rszcList:[],
            zcppList:[],
            szjsList:[]
        }
    },
    created(){
        this.$root.$children['0'].$children['0'].menuListOne.forEach(element =>element.On = false)
        this.sliderData = this.Base.GetFilesInfoByCid(5619,1,'',9,1); //banner
        this.bmjj = this.Base.GetSinglePageInfoByCid(5606);//部门简介
        this.xxggList = this.Base.GetNewsInfoByCid(5607,false,1,'',4); //信息公告
        this.rszcList = this.Base.GetNewsInfoByCid(5608,false,1,'',3);
        this.zcppList = this.Base.GetNewsInfoByCid(5610,false,1,'',4);
        this.szjsList = this.Base.GetNewsInfoByCid(5614,false,1,'',4);
        // console.log(this.sliderData);
    }

}
</script>
<style lang="less" scoped>
  .formBox{
    width: 5.45rem;
    margin: 0 auto;
    form{
      margin-top: 0.54rem;
    }
    /deep/.el-select{
        width: 100%;
        margin-bottom: 0.4rem;
        input{
          height: 0.8rem;
          line-height: 0.8rem;
          padding-left: 0.6rem;
        }
        .el-input__suffix{
          right: 0.33rem;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue